<template>
  <div class="vx-dropdown dropdown">
    <button
        :id="id"
        class="btn dropdown-toggle rounded-0"
        type="button"
        data-bs-toggle="dropdown"
        :class="[buttonClasses, classes]"
        :data-bs-auto-close="preventClose ? 'outside' : false"
        :aria-expanded="defaultOpen"
        :data-active="active"
        :data-bs-offset="offset"
        @click="$emit('click')"
    >
      <slot name="button"/>

      <v-icon
          :icon="icon"
          size="xs"
          class="dropdown-arrow ms-auto"
          v-if="!disableIcon"
      />
    </button>

    <div
        class="dropdown-menu"
        :aria-labelledby="id"
        :class="[dropdownClasses, collapse]"
        :style="styles"
    >
      <slot name="content"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VDropdown',
  props: {
    id: {
      type: String,
      required: true,
    },
    defaultOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonClasses: {
      type: String,
      required: false,
      default: '',
    },
    dropdownClasses: {
      type: String,
      required: false,
      default: '',
    },
    offset: {
      type: String,
      required: false,
      default: '0, 0',
    },
    icon: {
      type: String,
      default: 'chevron-down',
    },
    disableIcon: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    decorated: {
      type: Boolean,
      default: false,
    },
    decorationLocation: {
      type: String,
      default: 'right',
    },
    flat: Boolean,
    active: Boolean,
    preventClose: Boolean,
  },
  computed: {
    classes() {
      return {
        'pe-32': !this.disableIcon,
        'decorated': this.decorated,
        'decorated-top': this.decorationLocation === 'top',
        'decorated-right': this.decorationLocation === 'right',
        'decorated-bottom': this.decorationLocation === 'bottom',
        'decorated-left': this.decorationLocation === 'left',
      };
    },
    collapse() {
      return {
        'px-0 py-8': this.flat,
        'show': this.defaultOpen,
      };
    },
    styles() {
      return {
        'width': !!this.width ? `${ this.width }px` : '',
        'min-width': !!this.width ? `${ this.width }px` : '',
        'height': !!this.height ? `${ this.height }px` : '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VDropdown";
</style>

<style lang="scss">
.vx-dropdown .dropdown-menu {
  .nav-link {
    color: var(--vx-gray-600);

    &:hover,
    &.active {
      background-color: #EBFDF9;
    }

    &.active {
      color: var(--vx-primary) !important;
      font-weight: 600;
    }

    > .checkbox {
      input[aria-checked="true"] ~ .checkbox-label {
        color: var(--vx-primary) !important;
        font-weight: 600;
      }
    }
  }
}
</style>
